module.exports = __webpack_public_path__ + "img/二星高级大师@2x.683a41cb.png";